module.exports = __webpack_public_path__ + "img/plus_tab.31b86e0f.svg";